import React, {useEffect, useState} from 'react';
import './ChestOpeningHistoryPage.css';
import PageButton from '../../elements/PageButton/PageButton';
import Pagination from '../../elements/Pagination/Pagination';
import ChestOpeningHistoryItem from '../../ChestOpeningHistoryItem/ChestOpeningHistoryItem';
import {usePageAnalytics} from '../../../hooks/analytics/usePageAnalytics';
import {API_BASE} from '../../../utils/apiConfig';
import {addClassNameIfTrue} from "../../../utils/other/addClassNameIfTrue";
import {MENU_SOUND_MANAGER} from "../../../scenes/MenuSoundManager";

const PAGE_ID = 'ChestOpeningHistoryPage';
const PAGE_SIZE = 10;

function ChestOpeningHistoryPage({isAllOpenings, userId, userName, onBack, onUserClick}) {
  const [openings, setOpenings] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [cache, setCache] = useState(new Map());

  usePageAnalytics('ChestOpeningHistoryPage');

  useEffect(() => {
    const fetchOpenings = async () => {
      setLoading(true);
      setError(null);

      const cacheKey = `${isAllOpenings ? 'all' : userId}_${page}`;
      const cached = cache.get(cacheKey);
      if (cached) {
        setOpenings(cached.chestOpenings);
        setTotalPages(cached.totalPages);
        setLoading(false);
        return;
      }

      try {
        const url = isAllOpenings
          ? `${API_BASE}/admin/chest-openings?limit=${PAGE_SIZE}&page=${page}`
          : `${API_BASE}/users/${userId}/chest-openings?limit=${PAGE_SIZE}&page=${page}`;
        const res = await fetch(url, {
          credentials: 'include',
        });
        if (!res.ok) throw new Error('Failed to fetch chest opening history');
        const data = await res.json();
        setOpenings(data.chestOpenings || []);
        setTotalPages(data.totalPages || 1);
        setCache((prev) => {
          const next = new Map(prev);
          next.set(cacheKey, data);
          return next;
        });
      } catch (e) {
        console.error('Chest opening history error', e);
        setError('Не удалось загрузить историю открытий сундуков');
      } finally {
        setLoading(false);
      }
    };

    fetchOpenings();
  }, [page, cache, userId, isAllOpenings]);

  const handlePageChange = (newPage) => {
    MENU_SOUND_MANAGER.playMenuButtonClick();
    setPage(newPage);
  };

  let title;
  if (isAllOpenings) {
    title = 'Все открытия сундуков';
  } else {
    title = 'История открытий сундуков';
  }

  const isUserNameShown = userName && !isAllOpenings

  return (
    <>
      <h1
        className={`admin-user-profile-title ${addClassNameIfTrue(!isUserNameShown, 'history-page-title-margin-bottom')}`}
      >{title}</h1>

      {isUserNameShown && (
        <h1 className="admin-user-profile-name">{userName}</h1>
      )}

      {loading && <p className="chest-opening-history-page-status">Загрузка...</p>}
      {error && <p className="chest-opening-history-page-status chest-opening-history-page-status_error">{error}</p>}

      {!loading && !error && (
        <>
          {openings.length === 0 ? (
            <p className="chest-opening-history-page-status">Пока нет открытых сундуков</p>
          ) : (
            <>
              <div className="chest-opening-history-page-list">
                {openings.map((opening, index) => (
                  <ChestOpeningHistoryItem
                    key={opening._id}
                    opening={opening}
                    showUserName={isAllOpenings}
                    onClick={isAllOpenings ? () => onUserClick(opening.userId, opening.userName) : undefined}
                    pageId={PAGE_ID}
                    buttonId={`chest_opening_${index}`}
                  />
                ))}
              </div>
              <Pagination currentPage={page} totalPages={totalPages} onPageChange={handlePageChange}/>
            </>
          )}
        </>
      )}

      <div className="main-menu-buttons chest-opening-history-page-buttons">
        <PageButton onClick={onBack} pageId={PAGE_ID} buttonId="back">
          Назад
        </PageButton>
      </div>
    </>
  );
}

export default ChestOpeningHistoryPage;
